import { render } from "./ContactDetailsWidget.vue?vue&type=template&id=448295de"
import script from "./ContactDetailsWidget.vue?vue&type=script&lang=js"
export * from "./ContactDetailsWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__